export const getPMaxPlacementBaseStyles = () => ({
  placementCard: {
    border: '1px solid #c8c8c8',
    boxShadow: 'unset !important',
    borderRadius: '0px !important',
  },
  placementImageContainer: undefined,
  placementTextContainer: undefined,
  placementAdsLabel: undefined,
  placementGradient: undefined,
  placementShortHeadline: undefined,
  placementLongHeadline: undefined,
  placementFinalUrl: undefined,
  placementDescription: undefined,
  placementCallToAction: undefined,
  placementBusinessNameWithAdsLabel: undefined,
});

export const getPMaxMSNCarousel169x100Styles = (theme) => {
  const baseStyles = getPMaxPlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      width: '338px !important',
      height: 200,
      borderRadius: '6px !important',
      boxShadow: 'none !important',
    },

    placementImageContainer: {
      width: '100%',
      height: '100%',
      ...baseStyles.placementImageContainer,
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '194px',
      background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.54) 100%)',
    },

    placementInfoContainer: {
      paddingTop: '80px',
      height: '150px',
      boxSizing: 'border-box',
    },

    placementLongHeadline: {
      padding: '0px 16px',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '28px',
      lineHeight: '35px',
      color: 'rgba(255, 255, 255, 1)',
      display: '-webkit-box',
      '-webkit-box-orient': 'vertical',
      '-webkit-line-clamp': 2, /* Limit to 2 lines */
      overflow: 'hidden',
    },

    businuessAndAdChoiceContainer: {
      height: 44,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
    },

    adsLabelContainerClassName: {
      marginRight: 8,
      height: 16,
    },

    adsLabelClassName: {
      borderColor: 'rgba(255, 255, 255, 0.3) !important',
      color: 'white !important',
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      flexGrow: 1,
      color: 'white',
    },
  };
};

export const getPMaxMicrosoftEdgeCarousel201x100Styles = (theme) => {
  // base styles
  const baseStyles = getPMaxPlacementBaseStyles(theme);

  return {
    placementCard: {
      ...baseStyles.placementCard,
      borderRadius: '8px !important',
      width: '401px !important',
      height: 200,
    },

    placementTextContainer: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '280px',
    },

    placementGradient: {
      display: 'block',
      width: '100%',
      height: '178px !important',
      background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 50.03%, rgba(30, 30, 30, 0.34) 88.85%, rgba(0, 0, 0, 0.44) 100%)',
    },

    placementInfoContainer: {
      padding: '12px 16px 0px',
      minHeight: '62px',
      boxSizing: 'border-box',
      background: 'linear-gradient(360deg, rgba(0, 0, 0, 0.54) 5.47%, rgba(0, 0, 0, 0.54) 55.63%, rgba(0, 0, 0, 0.49) 78.44%, rgba(0, 0, 0, 0.475) 89.43%, rgba(0, 0, 0, 0.44) 100%)',
    },

    businuessAndLogoContainer: {
      display: 'flex',
      marginBottom: 8,
    },

    placementLogoContainer: {
      height: 16,
      width: 16,
      marginRight: 8,
      '& .cropped-image-view': {
        borderRadius: '2px !important',
        '& img': {
          verticalAlign: 'top',
        },
      },
    },

    placementBusinessNameContainer: {
      fontFamily: 'Segoe UI',
      fontWeight: 400,
      fontSize: 12,
      lineHeight: '16px',
      color: 'white',
    },

    placementShortHeadline: {
      color: 'white',
      fontFamily: 'Segoe UI',
      fontWeight: '600',
      fontSize: '20px',
      lineHeight: '26px',
    },

    businuessAndAdChoiceContainer: {
      height: 40,
      boxSizing: 'border-box',
      padding: '0px 16px',
      display: 'flex',
      alignItems: 'center',
      background: 'var(--backplate-text-backplate-on-image-text-backplate-54451, rgba(0, 0, 0, 0.54))',
    },

    headChoiceIconClassName: {
      marginRight: 8,
    },

    adsLabelContainerClassName: {
      flexGrow: 1,
      height: 16,
    },

    adsLabelClassName: {
      display: 'inline-block',
      verticalAlign: 'top',
      borderColor: 'rgba(255, 255, 255, 0.3) !important',
      color: 'white !important',
    },

    placementCallToAction: {
      border: '1px solid',
      borderImageSource: 'linear-gradient(180deg, rgba(0, 0, 0, 0.0578) 90.58%, rgba(0, 0, 0, 0.1622) 100%)',
      padding: '3px 8px',
      borderRadius: '4px',
      color: 'rgba(255, 255, 255, 1)',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'rgba(255, 255, 255, 0.15)',
    },

    placementCallToActionAsLink: {
      border: 'none',
      color: 'white',
      fontFamily: 'Segoe UI',
      fontWeight: '400',
      fontSize: '12px',
      lineHeight: '16px',
      backgroundColor: 'transparent',
    },
  };
};
